import React from 'react';
import cn from 'classnames';
import SvgIcon from '../../../../../../common/SvgIcon';

const OptionsListItemReaction = ({
  color,
  image,
  icon,
  reaction,
  value,
  title,
  disabled,
  onChange,
  shape,
  type
}) => (
  <div
    className={cn('onboarding-reaction', shape, type, {
      '-active': reaction === 'like',
      '-color': color,
      '-spacing': type !== 'inspirations',
      '-disabled': disabled,
    })}
    onClick={!disabled ? () => (reaction === 'like' ? onChange(value, 'dislike') : onChange(value, 'like')) : undefined}
  >
    {color ? (
      <div style={{ backgroundColor: color }} className={cn('onboarding-reaction_color')} />
    ) : (
      <div className={cn('onboarding-reaction_picture')}>
        {icon ? (
          <SvgIcon icon className="onboarding-reaction_image" />
        ) : (
          <img src={image} className={cn("onboarding-reaction_image ", { '-inspirations': type === 'inspirations' })} alt="" />
        )}
      </div>
    )}
    <div>{title && <div className="onboarding-reaction_title">{title}</div>}
      {/* <div className="onboarding-reaction__actions">
      <div
        className={cn('onboarding-reaction__action', {
          '-active': reaction === 'like',
          '-disabled': disabled,
        })}
        onClick={() => onChange(value, 'like')}
      >
        <Svg icon="icon-like" className="onboarding-reaction__icon" />
      </div>
      <div
        className={cn('onboarding-reaction__action -dislike', {
          '-active': reaction === 'dislike',
          '-disabled': disabled,
        })}
        onClick={() => onChange(value, 'dislike')}
      >
        <Svg icon="icon-like" className="onboarding-reaction__icon -dislike" />
      </div>
    </div> */}
    </div>
  </div>
);

export default OptionsListItemReaction;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/OptionsList/OptionsListItemReaction.js